import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { FormGroup, FormArray, FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { first } from 'rxjs/operators';
import Swal from 'sweetalert2';
import { ParentParameters, statusCode } from '../../../auth/models/commonEnum';
import { CommonService } from '../../../auth/service';
import { MyApplicationService } from '../my-application.service';

@Component({
	selector: 'app-bank-mandate-form',
	templateUrl: './bank-mandate-form.component.html',
	styleUrls: ['./bank-mandate-form.component.scss'],
	encapsulation: ViewEncapsulation.None
})
export class BankMandateFormComponent implements OnInit {

	public ID: string;
	public mandateDetails;
	public isApplicable: boolean = false;
	public loading = false;
	public bankAccountTypeSelected: { id: number; name: string; }[];
	public uploadCancelChequeUrl: String;
	public bondDocumentUrl: String;
	public signedDocumentUrl: String;
	public mandateFormURL: string;
	public hasDisabled: boolean | false;
	public hasMandateForm: boolean | false;
	constructor(private fb: FormBuilder, private _router: Router, private _myApplicationService: MyApplicationService,
		private _commonService: CommonService,
		private route: ActivatedRoute, private _formBuilder: FormBuilder) {
		
	}
	public bankdetailsform: FormGroup;
	public tinDetails = [];
	public bankAccountTypes = [];
	public contentHeader: object;
	displayField: boolean;
	submitted = false;
	ngOnInit(): void {
		this.route.params.subscribe(parmas => {
			this.ID = parmas["id"];
		});
		this.hasDisabled = true;
		this.hasMandateForm = false;
		this.tindetailsArray();
		this.loadBankAccountTypeData();
		
		this.bankdetailsform = this._formBuilder.group({
			id: [0,],
			applyonlineId: [],
			accountHolderName: ["", [Validators.required,]], //Validators.pattern('^.*[a-zA-Z0-9 ]+.*$')
			completeAddress: ["",[]],
			telephoneNo: ["",],
			faxNo: ["",],
			email: ["",[Validators.email]],
			isTinApplicable: ['0',],
			pan: ["",[Validators.pattern('[A-Z]{5}[0-9]{4}[A-Z]{1}')]],
			tinNumber: ["",],
			nameOfBank: ["", [Validators.required,]],
			addressOfBank: ["",[]],
			bankTelephoneNo: ["",],
			bankEmail: ["",[Validators.email]],
			nameOfBeneficiary: ["",[]],
			ifscCode: ["", [Validators.required,Validators.pattern('[A-Z]{4}[A-Z0-9]{7}')]],
			micrCode: ["",[]],
			ibanAccountNumber: ["",[]],
			bicSwiftCode: ["",[]],
			typeOfBankAccount: [,],
			completeAccountNumber: ["", [Validators.required]],
			cancelCheck: ["",],
			cancelCheckName: ["Select file",],
			mandateform: ["",],
			mandateformName: ["Select file",],
			uploadBoand: ["",],
			boandName: ["Select file",],
			isBondUpload: [0,]
		});
		this.getBankMandateDetail(this.ID);

		this.contentHeader = {
			headerTitle: 'Bank Mandate Form',
			actionButton: true,
			breadcrumb: {
				type: '',
				links: [
					{
						name: 'My Application',
						isLink: true,
						link: '/'
					},
					{
						name: 'Bank Mandate',
						isLink: false
					},
				]
			}
		};
	}

	tindetailsArray() {
		this.tinDetails.push(
			{
				tinName: 'Applicable',
				tinID: '1',
				selected: false
			},
			{
				tinName: 'Not Applicable',
				tinID: '0',
				selected: true
			}
		);
	}

	loadBankAccountTypeData() {
		this._commonService.getParameterSettings(ParentParameters.BANK_ACCOUNT_TYPES).subscribe((result: any) => {
			this.bankAccountTypes = [];
			if (result.statusCode == 200) {
				result["data"]["response"].forEach(element => {
					this.bankAccountTypes.push({
						name: element.paraDescription,
						id: element.paraId
					});
				});
			}
		});
	}

	onOptionsSelected(value) {
		let data = value;
		if (data == 1) {
			this.displayField = true;
		} else {
			this.displayField = false;
		}
	}
	/**
	 * Get FormData
	 */
	get bankFormData() {
		return this.bankdetailsform.controls;
	}

	getBankMandateDetail(id) {
		const data = {
			applyonlineId: id
		}
		this._myApplicationService.getBankMandateDetail(data).subscribe((result: any) => {
			if (result.statusCode == statusCode.SUCCESS) {
				this.mandateDetails = result["data"]["response"].mandateDetails;
				this.bankFormData.isBondUpload.setValue(result["data"]["response"].isBondUpload);
				if (this.mandateDetails != null && this.mandateDetails.id > 0) {
					this.bankdetailsform.patchValue(this.mandateDetails);
					this.bankdetailsform.controls.isTinApplicable.setValue(this.mandateDetails.isTinApplicable.toString());
					this.bankdetailsform.controls.typeOfBankAccount.setValue(parseInt(this.mandateDetails.bankAccountType));
					this.bankdetailsform.controls.id.setValue(this.mandateDetails.id);
					this.onOptionsSelected(this.mandateDetails.isTinApplicable);
					this.uploadCancelChequeUrl = this.mandateDetails.chequeDocumentUrl;
					this.bondDocumentUrl = this.mandateDetails.bondDocumentUrl;
					this.signedDocumentUrl = this.mandateDetails.signedMandateUrl;
					this.mandateFormURL = this.mandateDetails.mandateFormURL;
					this.hasDisabled = (this.mandateDetails.mandateFormURL.length > 0) ? false : true;
				}
				else{
					this.hasDisabled = true;
				}
			}
		})
	}
	public myFiles = [];
	public tempFiles = [];
	onFileChange(event: any, name: string, fileSize:any) {
		var validFileType = ['application/pdf', 'image/png', 'image/jpeg'];
		for (var i = 0; i < event.target.files.length; i++) {
			var filetype = event.target.files[i].type;
			if(validFileType.findIndex(v=> v == filetype) < 0){
				Swal.fire({
					title: 'Information',
					text: 'Invalid file type. Please upload File with extension: (.pdf, .png or .jpeg)',
					icon: 'info',
					customClass: {
						confirmButton: 'btn btn-success'
					}
				});
				return false;
			}
				var size = event.target.files[i].size;
				size = (size / 1024 / 1024);
				if(size > fileSize){
					Swal.fire({
						title: 'Information',
						text: 'Slected file size is too Big, please select a file less than: ' + fileSize + ' MB:)',
						icon: 'info',
						customClass: {
							confirmButton: 'btn btn-success'
						}
					});
					return false;
				}
			//this.myFiles = [];
			this.tempFiles = [];
			var key = name;
			this.myFiles.push({ key: key, file: event.target.files[i] });
			this.tempFiles.push({ key: key, file: event.target.files[i] });
			if (name === 'cancelCheck') {
				this.bankdetailsform.controls.cancelCheckName.setValue(this.showFiles(this.tempFiles));
			}
			if (name === 'uploadBoand') {
				this.bankdetailsform.controls.boandName.setValue(this.showFiles(this.tempFiles));
			}
			if (name === 'mandateform') {
				this.bankdetailsform.controls.mandateformName.setValue(this.showFiles(this.tempFiles));
				this.hasMandateForm = true;
			}
		}
	}

	showFiles(documentList: any) {
		let files = '';
		for (let i = 0; i < documentList.length; i++) {
			files += documentList[i].file.name;

			if (!(documentList.length - 1 === i)) {
				files += ',';
			}
		}
		return files;
	}

	browsbuttonClick(name) {
		if (name === 'cancelCheck') {
			this.bankdetailsform.controls.cancelCheckName.setValue("Select file");
		}
		if (name === 'uploadBoand') {
			this.bankdetailsform.controls.boandName.setValue("Select file");
		}
		if (name === 'mandateform') {
			this.bankdetailsform.controls.mandateformName.setValue("Select file");
			this.hasMandateForm = false;
		}
		if (this.myFiles.length > 0) {
			this.myFiles.forEach((element, i) => {
				if (element.key == name) {
					this.myFiles.splice(i, 1);
				}
			});
		}
	}

	onSave(){
		const self = this;
		this.submitted = true;
		if (this.bankdetailsform.invalid) {
			return false;
		}
		const details = self.prepareSave('save');
		this.loading = true;
		this._myApplicationService
			.submitBankMandateData(details).pipe(first())
			.subscribe(
				response => {
					if (Number(response["statusCode"]) === statusCode.SUCCESS) {
						this.submitted = false;
						Swal.fire({
							icon: 'success',
							title: 'Success!',
							text: 'Bank Mandate details saved successfully.',
							customClass: {
								confirmButton: 'btn btn-success'
							}
						});
						//this._router.navigate(['/my-application']);
						this.getBankMandateDetail(this.ID);
					}
					else {
						this.loading = false;
						Swal.fire({
							icon: 'error',
							title: 'Error!',
							text: response["message"],
							customClass: {
								confirmButton: 'btn btn-error'
							}
						});
					}
				},
			);

		return false;
	}

	onSubmit() {
		const self = this;
		this.submitted = true;
		if (this.bankdetailsform.invalid) {
			return false;
		}
		const details = self.prepareSave('submit');
		if(details == false){
			return false;
		}
		else{
			this.loading = true;
		this._myApplicationService
			.submitBankMandateData(details).pipe(first())
			.subscribe(
				response => {
					if (Number(response["statusCode"]) === statusCode.SUCCESS) {
						this.submitted = false;
						Swal.fire({
							icon: 'success',
							title: 'Success!',
							text: 'Bank Mandate details saved successfully.',
							customClass: {
								confirmButton: 'btn btn-success'
							}
						});
						this._router.navigate(['/my-application']);
					}
					else {
						this.loading = false;
						Swal.fire({
							icon: 'error',
							title: 'Error!',
							text: response["message"],
							customClass: {
								confirmButton: 'btn btn-error'
							}
						});
					}
				},
			);

		return false;
		}
	}

	showInfo(){
		Swal.fire({
			icon: 'info',
			title: 'Info!',
			text: "Upload the signed Mandate Form and Submit.",
			customClass: {
				confirmButton: 'btn btn-error'
			}
		});
	}

	prepareSave(type) {
		let input: FormData = new FormData();
		input.append('applyonlineId', this.ID);
		input.append('mandateId', this.bankdetailsform.controls.id.value);
		input.append('accountHolderName', this.bankdetailsform.controls.accountHolderName.value);
		input.append('completeAddress', this.bankdetailsform.controls.completeAddress.value);
		input.append('telephoneNo', this.bankdetailsform.controls.telephoneNo.value);
		input.append('faxNo', this.bankdetailsform.controls.faxNo.value);
		input.append('email', this.bankdetailsform.controls.email.value);
		input.append('pan', this.bankdetailsform.controls.pan.value);
		input.append('isTinApplicable', this.bankdetailsform.controls.isTinApplicable.value);
		input.append('tinNumber', this.bankdetailsform.controls.tinNumber.value);
		input.append('nameOfBank', this.bankdetailsform.controls.nameOfBank.value);
		input.append('addressOfBank', this.bankdetailsform.controls.addressOfBank.value);
		input.append('completeAccountNumber', this.bankdetailsform.controls.completeAccountNumber.value);
		input.append('bankEmail', this.bankdetailsform.controls.bankEmail.value);
		input.append('nameOfBeneficiary', this.bankdetailsform.controls.nameOfBeneficiary.value);
		input.append('ifscCode', this.bankdetailsform.controls.ifscCode.value);
		input.append('micrCode', this.bankdetailsform.controls.micrCode.value);
		input.append('ibanAccountNumber', this.bankdetailsform.controls.ibanAccountNumber.value);
		input.append('bankTelephoneNo', this.bankdetailsform.controls.bankTelephoneNo.value);
		input.append('bicSwiftCode', this.bankdetailsform.controls.bicSwiftCode.value);
		input.append('typeOfBankAccount', this.bankdetailsform.controls.typeOfBankAccount.value);

		if(type=='submit'){
			if(this.myFiles.length > 0 && this.myFiles.findIndex(t=>t.key == 'mandateform') != -1)
			{
				for (var i = 0; i < this.myFiles.length; i++) {
					input.append(this.myFiles[i].key, this.myFiles[i].file);
				}
			}
			else{
				Swal.fire({
					icon: 'info',
					title: 'Info!',
					text: "Upload the signed Mandate Form and Submit.",
					customClass: {
						confirmButton: 'btn btn-error'
					}
				});
				return false;
			}
		}
		else{
			for (var i = 0; i < this.myFiles.length; i++) {
				input.append(this.myFiles[i].key, this.myFiles[i].file);
			}
		}
		return input;
	}
}	
